import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import {getTemplateDetail,updateTemplateDetail } from "../../../../utils/chatApi";


//Import Widgets
import CommonTemplate from "../../../../components/Apps/ViberChat/Template/CommonTemplate";

//Import Tabs
import ConnectTab from "../../../../components/Apps/ViberChat/ConnectTab";
import ContentTab from "../../../../components/Apps/ViberChat/ContentTab";
import SettingTab from "../../../../components/Apps/ViberChat/SettingTab";
import AppearanceTab from "../../../../components/Apps/ViberChat/AppearanceTab";

export default function EditViberChat() { 
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    //const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Connect");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [chatTabData, setChatTabData] = useState({
        is_website_frontend: "", 
        viber_number: "",  
        bubble_icon: "",  
        bubble_text: "",  
        chat_window_picture: "",  
        chat_window_name: "",  
        chat_window_caption: "Online",  
        welcome_message: "",   
        start_chat_button_text: "Chat on Viber",  
        is_show_start_chat_button: 1,  
        position_alignment_type: "right-side",  
        position_vertical_offset: "",  
        position_horizonantal_offset: "",  
        chat_display_pages_type: "All_Pages",  
        chat_display_devices: ["Desktop", "Mobile Devices"],
        chat_display_visitors_type: "All_Visitors",  
        display_chat_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],  
        chat_display_is_schedule: 1,  
        chat_display_start_time: "12:00 AM",  
        chat_display_end_time: "1:00 AM",  
        chat_display_time_zone: "",  
        chat_triggers_is_on_page_load: 1,  
        chat_triggers_time_on_page: "",  
        chat_triggers_time_on_site: "",  
        chat_triggers_scroll_position: "",  
        chat_triggers_is_exit_intent: 1,  
        chat_triggers_remembers_visitors: "1 Day",  
        is_show_bubble_notification_badge: 1,  
        font_type: "",  
        chat_window_name_color: "",  
        chat_window_caption_color: "", 
        bubble_background_color: "",  
        bubble_icon_color: "",  
        notification_badge_color: "",  
        header_background_color: "",  
        header_text_color: "",  
        online_status_color: "",  
        chat_wallpaper_color: "",  
        message_background_color: "",  
        message_field_color: "",  
        button_color: "",  
        enable_animation: "",  
        animation_interval: "",  
        custom_css:  "",  
        custom_js: "", 
    });
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Viber Chat");
    const [newWidgetName, setNewWidgetName] = useState("");

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateChatTabData = (key, value) => {
        setChatTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Connect", icon: "connect.png", label: "Connect" },
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
        { key: "Appearance", icon: "apperance.png", label: "Appearance" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});
                    setChatTabData(settingsObject);
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid]);

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();
            const formData = new FormData();

            // Append text fields
            formData.append("template_id", isTemplateId);
            formData.append("name", widgetName);
            formData.append("template_name", activeTemplateSection);
            formData.append("template_image", extractedImageName);
            formData.append("layout_name", selectedLayout);
            formData.append("layout_type", selectedLayout);
            formData.append("app_type", 'Viber_Chat');
    
            // Append settings as JSON string
            formData.append(
                "settings",
                JSON.stringify(
                    Object.entries(chatTabData).map(([key, value]) => ({
                        setting_key: key,
                        setting_value: value,
                    }))
                )
            );

            // Check if chat_window_picture is a File and append it
            if (chatTabData.chat_window_picture) {
                // If it's a File object (newly uploaded), append it directly
                if (chatTabData.chat_window_picture instanceof File) {
                    formData.append("chat_window_picture", chatTabData.chat_window_picture);
                } 
                // If it's a string (from predefined template), just send the image file name
                else if (typeof chatTabData.chat_window_picture === 'string') {
                    const imageName = chatTabData.chat_window_picture.split('/').pop();
                    formData.append("chat_window_picture", imageName);
                }
            }

            //Api Call
            let api_response = await updateTemplateDetail(formData);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/viber-chat');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
          <div className="create-goole-reviews-all">
                <div className="overlay-side-baar">
                    <div className="side-baar-inner-one">
                        <ul>
                            {menuItems.map((item) => (
                                <li key={item.key}>
                                    <button
                                        className={activeSection === item.key ? "active" : ""}
                                        onClick={() => setActiveSection(item.key)}
                                    >
                                        <img
                                            src={`${process.env.PUBLIC_URL}/viber-chat/icons//${item.icon}`}
                                            alt={`${item.key} icon`}
                                        />
                                        <span>{item.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="side-baar-inner-tow">
                        {/* Conditional Rendering for Sections */}
                        {activeSection === "Connect" && (
                            <ConnectTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                        )}
                        
                        {activeSection === "Content" && (
                            <ContentTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                        )}

                        {activeSection === "Settings" && (
                            <SettingTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                        )}

                        {activeSection === "Appearance" && (
                            <AppearanceTab updateChatTabData={updateChatTabData} chatTabData={chatTabData}/>
                        )}
                    </div>
                </div>
                <div className="create-goole-reviews-right whtsapp-new-header">
                    <div className="content-wrapper">
                        <div className="source-header-row">
                            <h2><Link to="/customer/apps/viber-chat"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                            <div className="untitled-widget-name whtsapp-icon">
                                <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/viber-chat.svg`} alt="viber-chat"/>{ widgetName }</button>
                                <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                            </div>
                            <div className='submit-google-review'>
                              <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`}>Publish</button>
                              <Link to="/customer/apps/viber-chat/pricing/single" className="view-plan">View Plans</Link>
                              <Link to="/customer/apps/viber-chat" className="close-button">Close</Link></div>
                        </div>
                        <div className="source-title-row">Viber Chat <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                        {/*Call Common template*/}
                        <CommonTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateChatTabData={updateChatTabData} chatTabData={chatTabData} /> 
                    </div>
                </div>
            </div>

            {/* Rename Popup */}
            {renameWidgetNameModel && (
                <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                        <label>Widget Name</label>
                        <input
                            type="text"
                            className="border p-2 w-full mt-2"
                            value={newWidgetName}
                            onChange={(e) => setNewWidgetName(e.target.value)}
                        />
                        <div className="mt-3 flex justify-end">
                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                                Cancel
                            </button>
                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
      );
}
